import React from 'react'
import "./footer.css"

import PostData from './Languages/Lang/siteText.json'

const Footer = (props) => {
    const language = props.lang


    return (
        <>


        <div className='w-100 row mx-auto bg-dark text-light mt-5 p-3'>
            <div data-aos='flip-left' className='col-12 col-lg-4 contact-container'>
                <h1 className='display-1 contact-header'>
                    {language === "PL" && (<>
                    {PostData.map((postDetail, index) => {return postDetail.footertitle})}
                    </>)}
                    {language === "ENG" && (<>
                    {PostData.map((postDetail, index) => {return postDetail.footertitleENG})}
                    </>)}

                    {language === "GER" && (<>
                    {PostData.map((postDetail, index) => {return postDetail.footertitleGER})}
                    </>)}

                </h1>
                <div className='text-left'>
                    <p>MJG Serwis Sp. z o.o. Sp. K.</p>
                    <p>ul. Jedności Narodowej 238/14</p>
                    <p>50-302, Wrocław</p>
                    <p>NIP: PL8952186513</p>
                    <p>REGON: 369761859</p>
                    <p>KRS: 0000723096</p>
                    
                </div>
            </div>
            <div data-aos='flip-left' className='col-12 col-lg-4 footer-borders contact-container'>
                <h1 className='display-1 contact-header'>
                    {language === "PL" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footerphone})}
                    </>)}

                    {language === "ENG" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footerphoneENG})}
                    </>)}

                    {language === "GER" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footerphoneGER})}
                    </>)}

                </h1>
                    <div className='text-left'>
                    {language === "PL" && (<>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeradministration_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeradministration})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footertransport_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footertransport})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeraccounting_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeraccounting})}</p>
                        </>)}
                    {language ==="ENG" &&(<>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeradministration_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeradministrationENG})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footertransport_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footertransportENG})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeraccounting_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeraccountingENG})}</p>

                        </>)}
                    {language ==="GER" &&(<>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeradministration_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeradministrationGER})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footertransport_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footertransportGER})}</p>
                            <p>{PostData.map((postDetail, index) => {return postDetail.footeraccounting_VALUE})} – {PostData.map((postDetail, index) => {return postDetail.footeraccountingGER})}</p>

                    </>)}


                        </div>
                </div>
            <div data-aos='flip-left' className='col-12 col-lg-4 contact-container'>
                <h1 className='display-1 contact-header'>
                    {language === "PL" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footeremail})}
                    </>)}

                    {language === "ENG" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footeremailENG})}
                    </>)}

                    {language === "GER" && (<>
                        {PostData.map((postDetail, index) => {return postDetail.footeremailGER})}
                    </>)}

                </h1>
                <div className='text-left'>
                    {language === "PL" && (<>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailoffice_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailinvoices_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailrecrutation_VALUE})}</p>               
                    </>)}

                    {language ==="ENG" &&(<>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailoffice_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailinvoices_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailrecrutation_VALUE})}</p>               
                    </>)}

                    {language ==="GER" &&(<>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailoffice_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailinvoices_VALUE})}</p>
                        <p>{PostData.map((postDetail, index) => {return postDetail.footeremailrecrutation_VALUE})}</p>               
                    </>)}

                </div>
            </div>
        </div>
        
        {language ==="ESP" &&(
            <p>WEBSITE IN DEVELOPMENT</p>
        )}

        </>
        
    )
}

export default Footer
